import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

const StatusFilter = ({ value, onChange }) => {
  const safeValue = Array.isArray(value) ? value : [];

  const options = [
    { value: 'succeeded', label: 'Success' },
    { value: 'pending', label: 'Pending' },
    { value: 'failed', label: 'Failed' },
  ];

  return (
    <Autocomplete
      multiple
      options={options}
      value={options.filter((opt) => safeValue.includes(opt.value))}
      onChange={(_, selected) => onChange(selected.map((opt) => opt.value))}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      renderInput={(params) => (
        <TextField {...params} label="Status" size="medium" sx={{ minWidth: 200, marginBottom: '1rem' }} />
      )}
    />
  );
};

export default StatusFilter;
